export type CoreModule = {
  num: string
  icon: string
  title: string
  benefit: string
  subtitle: string
  desc: string
  includes: string[]
}

export const coreModules: CoreModule[] = [
  {
    num: '1',
    icon: '🧠',
    title: 'Cuaderno Mente Despierta',
    benefit: 'Para que la tarde tenga algo más que la tele.',
    subtitle: 'Estimulación cognitiva · Letra grande',
    desc: 'Actividades de memoria, atención, lenguaje y cálculo para acompañarlo sin complicaciones.',
    includes: [
      'Actividades cognitivas en letra grande',
      'Instrucciones claras para el cuidador',
      'Espacio de respuesta',
      'Seguimiento mensual',
    ],
  },
  {
    num: '2',
    icon: '🦵',
    title: 'Movilidad Sin Miedo',
    benefit: 'Para que se mueva sin que vos estés con el corazón en la boca.',
    subtitle: 'Ejercicios en silla y de pie',
    desc: 'Rutinas suaves de movilidad, equilibrio y fuerza con apoyo, explicadas con ilustraciones simples.',
    includes: [
      'Rutinas en silla',
      'Ejercicios de equilibrio y fuerza',
      'Ilustraciones claras',
      'Señales para detener y consultar',
    ],
  },
  {
    num: '3',
    icon: '🏥',
    title: 'Cuidado Experto',
    benefit:
      'Para saber qué mirar si tiene Alzheimer, Parkinson, diabetes o hipertensión.',
    subtitle: 'Alzheimer · Parkinson · Diabetes · Hipertensión',
    desc: 'Orientación práctica para organizar el acompañamiento diario ante condiciones frecuentes.',
    includes: [
      'Pautas de acompañamiento',
      'Organización de controles',
      'Señales de alarma',
      'Espacio para registrar información',
    ],
  },
  {
    num: '4',
    icon: '📋',
    title: 'Bitácora de Control 360',
    benefit: 'Para llegar a la consulta con todo anotado y no con papelitos.',
    subtitle: 'Medicación · Presión · Glucemia · Sueño',
    desc: 'Planillas para ordenar la información de salud y llevar un mejor registro diario.',
    includes: [
      'Registro de medicación',
      'Presión y glucemia',
      'Ánimo y sueño',
      'Consultas y estudios',
    ],
  },
  {
    num: '5',
    icon: '⭐',
    title: 'Guía del Cuidador',
    benefit: 'Para que el cuidado no caiga entero sobre una sola persona.',
    subtitle: 'Organización · Límites · Autocuidado',
    desc: 'Herramientas para organizar el cuidado, repartir responsabilidades y prevenir el agotamiento.',
    includes: [
      'Organización diaria',
      'Mapa familiar del cuidado',
      'Autocuidado del cuidador',
      'Ideas para pedir ayuda',
    ],
  },
]
